// extracted by mini-css-extract-plugin
module.exports = {"menuBg":"#fff","menuText":"#303133","menuActiveText":"#1890ff"};